import React, { useMemo } from "react";
import { Grid, Box } from "@mui/material";
import ApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const SPACER = "\u200B";

function DefineQuotaChart() {
   const define = useSelector((state) => state.define);
   const { quotaChartColors, quotaChartLabelNames, quotaChartSeriesData, showChart } =
      define;

   const chartLabels = useMemo(
      () => (Array.isArray(quotaChartLabelNames) ? [...quotaChartLabelNames, SPACER] : []),
      [quotaChartLabelNames]
   );

   const chartSeries = useMemo(
      () =>
         Array.isArray(quotaChartSeriesData)
            ? quotaChartSeriesData.map((s) => ({
                 ...s,
                 data: Array.isArray(s.data) ? [...s.data, null] : s.data,
              }))
            : quotaChartSeriesData,
      [quotaChartSeriesData]
   );

   const options = useMemo(
      () => ({
         chart: {
            zoom: {
               enabled: true,
            },
            animations: {
               enabled: false,
            },
            toolbar: {
               show: false,
            },
         },
         tooltip: {
            y: {
              formatter: (value) => {
                const formatter = new Intl.NumberFormat("en-US");
                return formatter.format(value);
              },
            },
          },
         grid: {
            show: false,
            padding: {
               right: 20,
               left: 12,
            },
         },
         xaxis: {
            tickPlacement: "on",
            labels: {
               formatter: (val) => (val === SPACER ? "" : val),
            },
         },
         labels: chartLabels,
         series: {
            type: "scatter",
         },
         yaxis: {
            labels: {
              formatter: (value) => {
                const formatter = new Intl.NumberFormat("en-US");
                return formatter.format(value);
              },
            },
         },
         colors: quotaChartColors,
         interpolateNulls: false,
         markers: {
            size: 4,
         },
         stroke: {
            width: 2,
            curve: "smooth",
         },
         noData: {
            text: "Loading Chart...",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
               color: "#000000",
            },
         },
      }),
      [chartLabels, quotaChartColors]
   );

   return (
      <Grid container columns={12} spacing={2} sx={{ display: showChart ? "block" : "none" }}>
         <Grid item xs={12}>
            <Box className={"DefineQuotaChart"}>
               <ApexChart
                  options={options}
                  series={chartSeries}
                  type="line"
                  height={450}
                  width={"100%"}
               />
            </Box>
         </Grid>
      </Grid>
   );
}

export default DefineQuotaChart;
